import BaseService from './base'

export default class AccountDataService extends BaseService {
  static resource() {
    return 'api/v1/external/accountData'
  }
}
